import { render, staticRenderFns } from "./PatientSurgeyConsumables.vue?vue&type=template&id=2af8ef92&scoped=true"
import script from "./PatientSurgeyConsumables.vue?vue&type=script&lang=js"
export * from "./PatientSurgeyConsumables.vue?vue&type=script&lang=js"
import style0 from "./PatientSurgeyConsumables.vue?vue&type=style&index=0&id=2af8ef92&prod&scoped=true&lang=css"
import style1 from "./PatientSurgeyConsumables.vue?vue&type=style&index=1&id=2af8ef92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af8ef92",
  null
  
)

export default component.exports